module.exports = __webpack_public_path__ + "static/media/udemy.297e0527.png";